export const FEEDBACK_GENERATION_STEP_STATUS = {
  COMPLETE: 'complete',
  ACTIVE: 'active',
  PENDING: 'pending',
};

export const DEFAULT_FEEDBACK_GENERATION_STEPS = [
  { id: 'comments', label: 'Adding specific comments' },
  { id: 'rubric', label: 'Marking rubric' },
  { id: 'successCriteria', label: 'Marking success criteria' },
  { id: 'summary', label: 'Adding summary comments' },
  { id: 'finalise', label: 'Finalising feedback' },
];

export const createFeedbackGenerationSteps = (
  statuses = DEFAULT_FEEDBACK_GENERATION_STEPS.map((step, index) => ({
    ...step,
    status: index < 2 ? FEEDBACK_GENERATION_STEP_STATUS.COMPLETE : FEEDBACK_GENERATION_STEP_STATUS.PENDING,
  })),
) => statuses;

export const computeFeedbackGenerationProgress = (steps = []) => {
  if (!steps.length) return 0;
  const completeCount = steps.filter(
    (step) => step.status === FEEDBACK_GENERATION_STEP_STATUS.COMPLETE,
  ).length;
  const hasActive = steps.some(
    (step) => step.status === FEEDBACK_GENERATION_STEP_STATUS.ACTIVE,
  );
  const weighted = completeCount + (hasActive ? 0.5 : 0);
  return Math.min(100, Math.round((weighted / steps.length) * 100));
};

export const deriveFeedbackGenerationStepsFromProgress = (progress = 0) => {
  const total = DEFAULT_FEEDBACK_GENERATION_STEPS.length;
  const clamped = Math.min(100, Math.max(0, progress));
  const weighted = (clamped / 100) * total;
  const completeCount = Math.floor(weighted);
  const hasActive = completeCount < total && weighted - completeCount >= 0.01;

  return DEFAULT_FEEDBACK_GENERATION_STEPS.map((step, index) => ({
    ...step,
    status:
      index < completeCount
        ? FEEDBACK_GENERATION_STEP_STATUS.COMPLETE
        : index === completeCount && hasActive
          ? FEEDBACK_GENERATION_STEP_STATUS.ACTIVE
          : FEEDBACK_GENERATION_STEP_STATUS.PENDING,
  }));
};
